//poprawić nazwy pól
export const errorMsgs = [
    {
        type: "emailRegex",
        msg: "Podaj prawidłowy adres email",
    },
    {
        type: "nipRegex",
        msg: "Podaj poprawny NIP",
    },
    {
        type: "phoneRegex",
        msg: "Podaj prawidłowy numer telefonu",
    },
    {
        type: "privacyPolicy",
        msg: "Musisz zaakceptować politykę prywatności",
    },
    {
        type: "urlRegex",
        msg: "Podaj prawidłowy adres strony www",
    },
];
//sprawdzić czy trzeba tutaj zmienić nazwy pól
export const regexData = [
    {
        type: "email",
        regex: new RegExp(
            "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
        ),
    },
    {
        type: "phone",
        regex: new RegExp(
            "(?:(?:(?:\\+|00)?48)|(?:\\(\\+?48\\)))?(?:1[2-8]|2[2-69]|3[2-49]|4[1-68]|5[0-9]|6[0-35-9]|[7-8][1-9]|9[145])\\d{7}"
        ),
    },
    {
        type: "website",
        regex: new RegExp("([--:\\w?@%&+~#=]*\\.[a-z]{2,4}\\/{0,2})((?:[?&](?:\\w+)=(?:\\w+))+|[--:\\w?@%&+~#=]+)?"),
    },
    {
        type: "nip",
        regex: new RegExp("^[0-9]{10}$"),
    },
];
